import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Title/Title.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
